import React, { useEffect } from "react";
// import FooterNew from "../components/Footer-New";
import Navbar from "../components/Navbar.js";
import NavbarFixed from "../components/Navbar-Fixed.js";

// import components
import ForgotPassword from "../components/ForgotPassword";
import NavbarNew from "../components/Navbar-New.js";
import FooterNew from "../components/Footer-New.js";



export default function ForgotPassPage(props) {
  return (
    <div>
     
      {/* <NavbarNew /> */}
      <div className="auth_wrapper">
        <ForgotPassword />
      </div>
      {/* <FooterNew /> */}
      {/* <NavbarFixed /> */}
    </div>
  );
}
